/*
 * @Description: 客户结算单
 * @Author: 杨志航
 * @Date: 2026-06-18 10:17:50
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import Main from './Main'
import ApprovalConfig from './ApprovalConfig'
import Detail from './Detail'
import Payback from './Payback'

const ProbationAchAudit = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/approvalConfig'} component={ApprovalConfig} />
      <Route path={match.path + '/detail'} component={Detail} />
      <Route path={match.path + '/payback'} component={Payback} />
      <CacheRoute component={Main} />
    </CacheSwitch>
  )
}

export default ProbationAchAudit